<template>
  <!-- 栏目列表 -->
  <div class="infoItem" @click="getDetail()">
    <!-- 图文项目内容 -->
    <div class="infoItemContent">
      <!-- 图片 -->
      <div class="liveImg">
        <img class="infoItemImg" :src="liveCoverImg" alt="暂无图片" />
        <div class="liveStatus">
          {{
            liveStatus === '0'
              ? '即将直播'
              : liveStatus === '1'
              ? '直播中'
              : '历史直播'
          }}
        </div>
      </div>
      <!-- 图文项目文本 -->
      <div class="inforItemText">
        <!-- 图文项目标题 -->
        <div class="infoItemTitle">
          <span>{{ liveName }}</span>
        </div>
        <!-- 图文项目讲师 -->
        <div class="infoItemDes">
          <span>{{ liveLecturers }}</span>
        </div>

        <!-- 简介 -->
        <div class="infoItemPrice">
          <span class="price" v-show="livePay === 0"
            >¥&nbsp;{{ liveAmt.toFixed(2) }}</span
          >
          <span class="free" v-show="livePay === 1">免费</span>
          <span v-if="total" class="count"
            >{{ total }}人{{ status === '2' ? '收藏' : '点赞' }}</span
          >
          <span v-if="liveStatus === '2' && !total && liveAttr" class="count">
            <span>
              <img src="../../assets/img/yanjing.png" alt />
              {{ JSON.parse(liveAttr).lookNum }}
            </span>
          </span>
        </div>
        <div class="infoItemDes2" v-if="liveStatus === '0'">
          <span>开始时间：{{ liveStartTime.substring(0, 19) }}</span>
        </div>
        <div class="infoItemDes2" v-if="liveStatus === '1'">
          <span>结束时间：{{ liveEndTime.substring(0, 19) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'liveCoverImg',
    'livePay',
    'liveAmt',
    'liveLecturers',
    'liveName',
    'liveCoverImg',
    'liveId',
    'liveStatus',
    'total',
    'status',
    'liveStartTime',
    'liveEndTime',
    'liveAttr',
  ],
  data() {
    return {
      dataForm: {
        currPage: 0,
        liveList: [],
        pageSize: 0,
        totalCount: 0,
        totalPage: 0,
      },
      pageIndex: 1,
      busy: false,
    }
  },
  methods: {
    getDetail() {
      // this.$router.push({
      //   path: '/details',
      //   query: {
      //     liveId: this.liveId,
      //   },
      // })
      const routeData = this.$router.resolve({
        path: '/details/',
        query: { liveId: this.liveId }
      })
      window.open(routeData.href, '_blank')
      // location.reload()
    }
  }
}
</script>
<style lang="scss" scoped>
/* 每一个图文项目的外层 */
a {
  text-decoration: none;
  color: #333;
}
.inforItemText {
  margin-left: 2rem;
  width: 65%;
}
/* 图文项目的标题信息 */
.infoItemTitle {
  font-size: $font-title2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: -o-ellipsis-lastline;
}
/* 图文项目的内容信息(弹性布局) */
.infoItemContent:last-child {
  border-bottom: 0;
}
.infoItemContent {
  display: flex;
  align-items: center;
  padding: 0.2rem 0;
  margin: 0.2rem 0;
  width: 100%;
  border-bottom: 1px solid #eee;
  .liveImg {
    position: relative;
    .liveStatus {
      position: absolute;
      right: 0;
      bottom: 0;
      color: #fff;
      padding: 2px 1rem;
      border-radius: 1rem;
      font-size: 12px;
      background-color: rgba($color: #000000, $alpha: 0.8);
    }
  }
}
/* 图文项目的内容信息--图片 */
.infoItemImg {
  width: 100px;
  height: 75px;
  border-radius: 5px;
}
/* 图文项目的内容信息--简介 */
.infoItemDes {
  // line-height: 20px;
  color: #666;
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin: 3px 0;
}
.infoItemDes2 {
  // line-height: 15px;
  color: #666;
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  // margin: 5px 0;
}
.infoItemPrice {
  font-size: 14px;
  color: #999;
  padding-bottom: 5px;
  .free {
    padding: 2px;
    margin-right: 4rem;
    font-size: 12px;
    background-color: $theme-color;
    border-radius: 3px;
    color: #fff;
  }
  .price {
    padding: 2px;
    margin-right: 1rem;
    color: $theme-color;
  }
  .count {
    float: right;
    width: 100px;
    padding-top: 2px;
  }
}
</style>
